/**
 * Escape a value for safe interpolation into an HTML string.
 * Use whenever a database/user-provided value is concatenated into
 * `document.write`, `innerHTML`, or other raw HTML sinks (e.g. print windows).
 */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
